const stop = () => window.ScanThng.stopScanQrCode(); // ScanThng throws an error on unmount if it can't find its container, preventing it from stopping its ongoing network requests. So far I haven't found any way to fix this without switching to a class-based component and using the componentWillUnmount hook

const streamApi = {
	scan: (options) =>
		window.evrythngToken.scanStream(options).finally(() => {
			stop();
		}), // leave this as arrow function syntax, a direct reference does not work
	stop,
};

export default streamApi;
